import { Alert, Button } from "reactstrap";

interface Props {
  membershipCategory: string;
  handleNext: (event: any) => void;
  handlePrevious: (event: any) => void;
}

// MemberAccountForm
export const StepThree: React.FC<Props> = ({ membershipCategory, handleNext, handlePrevious }) => {

	return (
		<>
			<h2 className='pt-5 pb-3 font-weight-bold'><strong>会員カテゴリーチェック / Confirmation of Membership Eligibility</strong></h2>
      <div className="pt-5">
        {(membershipCategory === "CORPORATE MEMBER/法人会員") && (
          <div>
            <Alert fade={false}>
              <h5 className="alert-heading"><strong>法人会員 (Corporate Member)</strong></h5>
              <hr />
              <p>マレーシアで設立され、その資本金の全部もしくは一部が日本国法人、または日本人に帰属する法人</p>
            </Alert>
          </div>)}

        {(membershipCategory === "INDIVIDUAL MEMBER/個人会員") && (
          <div>
            <Alert fade={false}>
              <h5 className="alert-heading"><strong>個人会員 (Individual Member)</strong></h5>
              <hr />
              <p>マレーシアの現地企業で雇用されている日本人</p>
              <p>※個人会員は、マレーシアまたは日本以外の外資系企業で労働ビザを取って働かれている日本人のみを対象としています。</p>
            </Alert>
          </div>)}

        {(membershipCategory === "SUB MEMBER/準会員") && (
          <div>
            <Alert fade={false}>
              <h5 className="alert-heading"><strong>準会員 (Sub Member)</strong></h5>
              <hr />
              <p>マレーシアに所在し、日系企業の出資がなく、日本人の従業員の在籍がないローカル企業</p>
            </Alert>
          </div>)}

        {(membershipCategory === "OVERSEAS MEMBER/在外会員") && (
          <div>
            <Alert fade={false}>
              <h5 className="alert-heading"><strong>在外会員 (Overseas Member)</strong></h5>
              <hr />
              <p>マレーシア国外において登録された日本の法人、その支店または連絡事務所であって、マレーシアにおいて商行為その他の業務を行っていること</p>
            </Alert>
          </div>)}

        {(membershipCategory === "none") && (
          <Alert fade={false} color="danger">
            <p>入会資格を満たしておりません。</p>
            <p>下記メールアドレスにお問い合わせください。</p><br />
            <p>JACTIM事務局: jactim@jcci.com.my</p><br />
            <hr /><br />
            <p>Sorry, you have not yet met the requirements.</p>
            <p>Please kindly send an inquiry to the email below.</p><br />
            <p>JACTIM Secretariat: jactim@jcci.com.my</p>
          </Alert>)}
      </div>
      <div className='justify-content-end pt-5 d-flex gap-3'>
        <Button 
          color="secondary" 
          outline
          onClick={handlePrevious}
          >戻る / Previous
        </Button>
        {(membershipCategory !== "none") && (
          <Button 
            color="info" 
            outline
            onClick={handleNext}
            >次へ / Next
          </Button>
        )}
      </div>
		</>
	)
}

export default StepThree;